<template>
  <div class="form">
    <OurGroup class="form-group">
      <OurInput
        v-model="form.applicationId"
        :label="$t('label.id')"
        :placeholder="$t('placeholder.id')"
      />

      <OurInput
        v-model="form.taxNumber"
        :label="$t('label.personalTaxNumber')"
        :placeholder="$t('placeholder.personalTaxNumber')"
      />

      <OurInput
        v-model="form.companyCode"
        :label="$t('label.taxNumber')"
        :placeholder="$t('placeholder.taxNumber')"
      />

      <OurPhoneInput
        v-model="form.phone"
        :label="$t('label.phone')"
        :placeholder="$t('placeholder.phone')"
        :flags="false"
        dropdown-disabled
      />

      <OurInput
        v-model="form.email"
        :label="$t('label.email')"
        :placeholder="$t('placeholder.email')"
      />

      <OurInput
        v-model="form.fullName"
        :label="$t('label.fullName')"
        :placeholder="$t('placeholder.fullName')"
      />

      <OurMultiselect
        v-model="form.statuses"
        :label="$t('label.status')"
        :placeholder="$t('placeholder.selectStatus')"
        :options="getStatuses()"
        item-label="text"
        value-key="value"
      />

      <OurMultiselect
        v-model="form.regionIds"
        :label="$t('label.region')"
        :placeholder="$t('placeholder.selectRegion')"
        :options="regionsForSelect"
        item-label="label"
        value-key="id"
      />

      <OurMultiselect
        v-model="form.managerIds"
        :label="$t('label.manager')"
        :placeholder="$t('placeholder.selectManager')"
        :options="managers"
        item-label="name"
        value-key="id"
      />

      <OurDateRangePicker
        v-model="form.date"
        variant="input"
        :label="$t('label.date')"
        :placeholder="$t('placeholder.selectDate')"
      />

      <OurCheckbox v-model="form.withoutManager" :label="$t('label.withoutManager')" />
    </OurGroup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FilterForm",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    regions: {
      type: Array,
      default: () => [],
    },
    managers: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      form: {
        applicationId: "",
        companyCode: "",
        taxNumber: "",
        phone: "",
        email: "",
        fullName: "",
        statuses: [],
        regionIds: [],
        managerIds: [],
        date: {},
        withoutManager: false,
      },
    };
  },

  computed: {
    ...mapGetters("dealershipApplications", ["getStatuses"]),

    regionsForSelect() {
      const locale = this.$i18n.locale;
      const apiLocale = locale === "uk" ? "ua" : locale;

      return this.regions.map((region) => ({
        id: region.id,
        label: region.name?.[apiLocale] || "",
      }));
    },
  },

  watch: {
    value: {
      handler: "setForm",
      deep: true,
    },

    form: {
      handler: "onChangeForm",
      deep: true,
    },
  },

  mounted() {
    this.setForm();
  },

  methods: {
    setForm() {
      this.form = this.value;
    },

    onChangeForm() {
      this.$emit("input", this.form);
    },
  },
};
</script>
